import { render, staticRenderFns } from "./SecurityLayout.vue?vue&type=template&id=19a39c6f&scoped=true"
import script from "./SecurityLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurityLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SecurityLayout.vue?vue&type=style&index=0&id=19a39c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a39c6f",
  null
  
)

export default component.exports